import styles from './index.module.less';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import { App, Button, Form, Input } from 'antd';
import Link from 'next/link';
// import { EmailIcon } from 'react-share';
import { useUserProvider } from '@/context/UserProvider';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { useConfigProvider } from '@/context/ConfigProvider';
import { useTranslation } from 'next-i18next';
import { isEmailValid } from '@/shared/utils';
import { UserOutlined } from '@ant-design/icons';
import { getExistEmail } from '@/lib/service';

const ForgotPassword = () => {
  const { message } = App.useApp();
  const { onChangedLoginView } = useUserProvider();
  const [isSendPage, setIsSendPage] = useState(true);
  const [email, setEmail] = useState('');
  const { isBlogWeb } = useConfigProvider();
  const router = useRouter();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const onSendFinish = (values: any) => {
    if (loading) {
      return;
    }
    setLoading(true);

    setEmail(values?.email);

    getExistEmail(values?.email)
      .then((res) => {
        if (res?.code === 0) {
          const auth = getAuth();
          sendPasswordResetEmail(auth, values?.email)
            .then(() => {
              message.success('Email send successful');
              setIsSendPage(false);
            })
            .catch((error) => {
              message.error(t('Email_Sending_Failed_Error_Msg'));
            })
            .finally(() => {
              setLoading(false);
            });
        } else {
          message.error(res?.message);
          setLoading(false);
        }
      })
      .catch(() => {
        message.error(t('Email_Sending_Failed_Error_Msg'));
        setLoading(false);
      });
  };

  useEffect(() => {
    if (isBlogWeb) {
      router.push('/blog');
    }
    setIsSendPage(true);
  }, []);

  if (isBlogWeb) {
    return <></>;
  }

  return (
    <CommonBackContent>
      <div className={styles.content}>
        {isSendPage ? (
          <Form
            name="normal_login"
            className={styles.topContainer}
            initialValues={{ email: email }}
            onFinish={onSendFinish}
          >
            <Form.Item>
              <div className={styles.title}>{t('ResetYourPassword')}</div>
              <div className={styles.desc}>{t('EnterYourEmailAddress_Desc')}</div>
            </Form.Item>
            <Form.Item
              name="email"
              rules={[
                { required: true, message: t('pleaseInputYourEmail') },
                () => ({
                  validator(_, value) {
                    if (!value || isEmailValid(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t('pleaseInputYourEmail')));
                  },
                }),
              ]}
            >
              <Input
                className={styles.inputContent}
                prefix={<UserOutlined style={{ color: '#B3B3B3', fontSize: '20px' }} />}
                // type="email"
                placeholder={t('EmailAddress')}
              />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" className={styles.loginBtn} loading={loading}>
                {t('Continue')}
              </Button>
              <Link
                href={'/login'}
                className={styles.backToLogin}
                onClick={() => {
                  onChangedLoginView(true);
                }}
              >
                {t('BackToLogIn')}
              </Link>
            </Form.Item>
          </Form>
        ) : (
          <div className={styles.topContainer}>
            <img src="/images/user/send-email-top-icon.png" alt="" className={styles.topEmailIcon} />
            <div className={styles.title}>Check Your Email</div>
            <div
              className={styles.desc}
              dangerouslySetInnerHTML={{
                __html: t('PleaseCheckTheEmailAddress_forInstructionsToResetYourPassword').replace(
                  'xxx',
                  `<span>${email}</span>`,
                ),
              }}
            >
              {/* Please check the email address <span>{email}</span> for instructions to reset your
              password. */}
            </div>

            <Button type="primary" onClick={() => setIsSendPage(true)} className={styles.loginBtn}>
              Resend email
            </Button>
          </div>
        )}
      </div>
    </CommonBackContent>
  );
};

export default ForgotPassword;
